<template>
    <Progressbar v-if="loading" />
    <NetworkError v-else-if="!persons.length && errors" @tryAgain="getPersons" />
    <div class="w-full h-full bg-gray-200 dark:bg-base-100 rounded-tr-3xl xl:px-9 pt-6 lg:pt-10 pb-14 " v-else>
        <div class="container">
            <div class="flex flex-col md:flex-row justify-between items-center md:items-center mb-6 lg:mb-8">
                <h3 class="flex items-center md:text-26 text-2xl dark:text-white text-biscay-700 font-semibold">
                    <i class="md:flex hidden w-2 h-2 dark:bg-white rounded-full bg-blue-700 ml-2"></i>
                    {{ __('Persons') }}
                </h3>
                <div class="flex mt-6 md:mt-0 flex-col lg:flex-row w-full md:w-auto justify-end">
                    <div class="flex mt-4 lg:mt-0 justify-end">
                        <input
                            class="input w-full h-10 xl:pl-36 placeholder-gray-320 md:w-64 xl:w-80 ml-2 bg-gray-350 bg-opacity-10 rounded-lg  transition duration-200 text-sm text-gray-350 px-3 font-medium dark:!bg-base-300 dark:!text-white  focus:bg-blue-700 focus:bg-opacity-10 border border-blue-700  focus:border-opacity-100"
                            type="text" :placeholder="__('Search...')" v-model="searchValue">
                        <button @click="search"
                            class=" bg-blue-600 disabled:opacity-70 disabled:!bg-blue-600 flex items-center h-10 md:px-5 px-3 rounded-md text-white font-semibold text-sm transition duration-200 hover:bg-blue-800 ">
                            {{ __('Search') }}
                        </button>
                    </div>
                        <Dropdown customClass="inline-block z-1 mr-2"
                            :labelClass="['px-2', { 'btn-outline': !hasFilter }]">
                            <template #label>
                                <FunnelIcon class="w-5 h-5" />
                            </template>
                            <div class="mt-3 card card-compact dropdown-content w-72 bg-base-100 shadow">
                                <div class="card-body">
                                    <div class="flex flex-col">
                                        <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium">
                                            {{ __('Birthday filter') }}
                                        </label>
                                        <select class="select w-full max-w-xs" v-model="filters.birthday_filter">
                                            <option value="">{{ __('Select...') }}</option>
                                            <option v-for="item in birthdayFilterOptions" :key="item.value"
                                                :value="item.value">{{ __(item.label) }}</option>
                                        </select>
                                    </div>
                                    <div class="flex flex-col"
                                        v-if="['exact', 'month'].includes(filters.birthday_filter)">
                                        <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium">
                                            {{ __('Birth month') }}
                                        </label>
                                        <select class="select w-full max-w-xs" v-model="filters.birth_month">
                                            <option value="">{{ __('Select...') }}</option>
                                            <option v-for="(month, index) in monthNames" :key="index" :value="index + 1">
                                                {{ __(month) }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="flex flex-col" v-if="filters.birthday_filter === 'exact'">
                                        <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium">
                                            {{ __('Birth day') }}
                                        </label>
                                        <select class="select w-full max-w-xs" v-model="filters.birth_day">
                                            <option value="">{{ __('Select...') }}</option>
                                            <option v-for="day in birthDays" :key="day" :value="day">{{ day }}</option>
                                        </select>
                                    </div>
                                    <div class="card-actions">
                                        <button class="btn btn-primary btn-block" :disabled="birthdayFilterIncomplete"
                                            @click="setFilter">
                                            {{ __('Apply Filter') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Dropdown>
                        <div class="flex justify-end order-first lg:order-last lg:mr-4" v-if="can('person.create')">
                            <router-link :to="{ name: 'user.person.create' }" class="btn btn-outline btn-info btn-base">
                                <span class="mt-0.5">{{ __('Create person') }}</span>
                            </router-link>
                        </div>
                </div>
            </div>
            <div class="rounded-2xl dark:bg-base-300 bg-white">
                <div class=" overflow-auto">
                    <table class="table table-xs md:table-sm xl:table-md" v-if="persons.length">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th> {{ __('Full Name') }} </th>
                                <th> {{ __('Phone number') }} </th>
                                <th> {{ __('Date of birth') }} </th>
                                <th> {{ __('Email') }} </th>
                                <th> {{ __('Account name') }} </th>
                                <th> {{ __('User') }} </th>
                                <th> {{ __('Created At') }} </th>
                                <th> {{ __('Action') }} </th>
                            </tr>

                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in persons">
                                <td> {{ (meta.per_page * (meta.current_page - 1)) + index + 1 }} </td>
                                <td> {{ item.name }} </td>
                                <td> {{ item.phone || '---' }} </td>
                                <td dir="ltr"> {{ item.birthdate || '---' }} </td>
                                <td> {{ item.email || '---' }} </td>
                                <td> {{ item.account_name }} </td>
                                <td> {{ item.user }} </td>
                                <td> {{ item.created_at }}</td>
                                <td>
                                    <router-link :to="{ name: 'user.person.show', params: { id: item.id } }"
                                        :class="{ 'btn-disabled': !can('person.view.all') && !can('person.view.self', item.self) }"
                                        class="btn btn-outline btn-primary btn-sm ml-2">
                                        {{ __('Show') }}
                                    </router-link>
                                    <router-link :to="{ name: 'user.person.edit', params: { id: item.id } }"
                                        :class="{ 'btn-disabled': !can('person.delete.all') && !can('person.delete.self', item.self) }"
                                        class="btn btn-outline btn-info btn-sm ml-2">
                                        {{ __('Edit') }}
                                    </router-link>
                                    <label @click="setItem(item)" for="delete-modal"
                                        :class="{ 'btn-disabled': !can('person.delete.all') && !can('person.delete.self', item.self) }"
                                        class="btn btn-outline btn-error btn-sm">
                                        {{ __('Delete') }}
                                    </label>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="col-span-12 flex flex-col items-center mt-9" v-else>
                        <NotFound />
                    </div>
                </div>
            </div>
            <Pagination :meta="meta" @setPage="setPage" class="!mt-6" />
        </div>
    </div>

    <ModalDelete @remove="removePerson" :title='__("Delete person")' :content='__("Are you sure to delete this person?")' />
</template>
<script setup>
import { ref, onMounted, computed, reactive } from 'vue';
import { FunnelIcon } from '@heroicons/vue/24/outline';
import { birthdayDays, birthdayFilterIsIncomplete, birthdayFilterOptions, jalaliMonthNames, normalizeBirthdayFilters } from '../../composables/birthdayFilters';

const { getPersons, loading, errors, meta, router, remove, route, persons, removePerson } = useDashboard();
const searchValue = ref(route.query.search || '');
const { birthday_filter, birth_month, birth_day } = route.query;
const filters = reactive({
    birthday_filter: birthday_filter || '',
    birth_month: birth_month ? Number(birth_month) : '',
    birth_day: birth_day ? Number(birth_day) : '',
});
const monthNames = jalaliMonthNames;
const birthDays = computed(() => birthdayDays(filters.birth_month));
const birthdayFilterIncomplete = computed(() => birthdayFilterIsIncomplete(filters));
const hasFilter = ref(Object.values(filters).some(value => value));
const setQuery = (key, value) => {
    getPersons(window.setQuery(router, route, key, value));
}
const setPage = (p) => {
    setQuery('page', p.toString());
};
const setItem = (item) => Object.assign(remove, item);
const search = () => {
    setQuery('search', searchValue.value)
}
const setFilter = () => {
    normalizeBirthdayFilters(filters);
    hasFilter.value = Object.values(filters).some(value => value);
    getPersons(window.setQueries(router, { ...route.query, ...filters, page: undefined }));
}
onMounted(() => {
    getPersons(route.query);
});
</script>
